module.exports = __webpack_public_path__ + "static/media/trip_key_12.7136d890.png";